<template>
  <el-dialog
    v-drag
    title="核销"
    :visible.sync="dialogVisible"
    width="990px"
    :show-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
    top="5vh"
  >
    <div class="content">
      <div class="data">
        <BaseTable
          :height="480"
          :tableData="tableData"
          :loading="loading"
          :isPager="false"
          :border="true"
        >
        </BaseTable>
      </div>
    </div>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取 消</div>
    </span>
  </el-dialog>
</template>
<script>
const BaseTable = () => import('@/components/table/BaseTable')
import {
  verifySurcharges
} from '@/api/fee'
export default {
  components: {
    BaseTable
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      tableData: {
        fileds: [
          {
            filed: 'blNo',
            label: '提单号码',
            width: '150',
            resizable: true
          },
          {
            filed: 'containerNumber',
            label: '柜号',
            width: '150',
            resizable: true
          },
          {
            filed: 'feeTypeName',
            label: '费用类型',
            width: '150',
            resizable: true,
            formatter: row => {
              return `${row.feeTypeCode} ${row.feeTypeName}`
            }
          },
          {
            filed: 'feeName',
            label: '费用细类',
            width: '150',
            resizable: true,
            formatter: row => {
              return `${row.feeNameCode} ${row.feeName}`
            }
          },
          {
            filed: 'createType',
            label: '类型',
            width: '150',
            resizable: true,
            formatter: row => {
              return row.createType ? '手动新增' : '系统自动生成'
            }
          },
          {
            filed: 'unitPrice',
            label: '单价',
            width: '100',
            resizable: true
          },
          {
            filed: 'qty',
            label: '数量',
            width: '100',
            resizable: true
          },
          {
            filed: 'amount',
            label: '金额',
            width: '100',
            resizable: true,
            formatter: row => {
              return `${row.amount} ${row.currency}`
            }
          },
          {
            filed: 'createdOn',
            label: '扣费日期',
            width: '150px',
            resizable: true
          },
          {
            filed: 'isGenerateInvoice',
            label: '账单',
            width: '100',
            resizable: true,
            formatter: row => {
              return row.isGenerateInvoice ? '是' : '否'
            }
          }
        ],
        columns: []
      },
      loading: false
    }
  },
  watch: {
    async dialogVisible(val) {
      if (val) {
        this.getLists({ verifyDetailId: this.rowData.verifyDetailId })
      }
    }
  },
  methods: {
    async getLists(params) {
      try {
        this.loading = true
        const res = await verifySurcharges(params)
        this.loading = false
        if (res.success) {
          this.tableData.columns = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    handleSelectionChange(val) {
      this.selectArr = val
    },
    cancel() {
      this.tableData.columns = []
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  .header {
    width: 100%;
    background: #FBFBFB;
    border-radius: 6px 6px 6px 6px;
    padding: 16px 32px;
    box-sizing: border-box;
    .label {
      display: inline-block;
      width: 94px;
      height: 16px;
      background: rgba(105, 89, 205, 0.1);
      border-radius: 4px 4px 4px 4px;
      text-align: center;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 12px;
      color: #6959cd;
      line-height: 16px;
    }
    .value {
      height: 16px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 12px;
      color: #666666;
      line-height: 16px;
      margin-left: 6px;
    }
  }
  .data {
    width: 100%;
    border-radius: 4px 4px 4px 4px;
    margin-top: 12px;
    .fTable {
      height: 448px;
    }
    .select {
      margin-top: 10px;
      font-size: 12px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      display: flex;
      height: 32px;
      line-height: 32px;
      padding: 0 32px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      span {
        color: rgb(18, 88, 188);
      }
      .money {
        color: #FF7C4B;
      }
    }
  }
}
.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 16px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background: rgb(18, 88, 188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}
</style>
